import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const CreateAssessmentRunsMutation = graphql(`
    mutation CreateAssessmentRuns($input: CreateAssessmentRunsInput!) {
        createAssessmentRuns(input: $input) {
            __typename
            ... on CreateAssessmentRunsSuccessfulResponse {
                result {
                    id
                    name
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export type CreateAssessmentRunsMutationVariables = VariablesOf<typeof CreateAssessmentRunsMutation>;
